export const calculateFinalCost = (rate: number): number => {
  if (!rate || rate < 0) {
    return 0;
  }
  const costWithCommission = rate * 1.25;
  return Math.ceil(costWithCommission);
};